import Section from "@/components/Section";
import { Eye, EyeOff, Upload, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ImageUpload({ pricing, images = [], handleImages, removeImage, toggleImage }) {

	const { t} = useTranslation();

	return (
		<Section title={t('horse.images_section')}>
			<p className="text-sm text-[#666055] mb-4" data-testid="image-pricing-info">
				{t('horse.image_pricing', { limit: pricing.free_images_limit, price: pricing.price_extra_image?.toFixed(2) })}
			</p>
			<div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
				{images.map((img, i) => (
					<div key={i}
							 className={`relative aspect-square rounded-sm overflow-hidden border-2 transition-all ${img.enabled ? 
								 		'border-[#E6E2D6]' : 'border-red-300 opacity-40'}`}
							 data-testid={`image-thumb-${i}`}>
						<img src={img.thumbnail || img.preview} alt="" className="w-full h-full object-cover" />
						{img.isExisting &&
							<span className="absolute bottom-1 left-1 text-[8px] bg-black/50 text-white px-1 rounded">
								{ t('common.saved') }
							</span>
						}
						<div className="absolute top-1 right-1 flex gap-1 z-10">
							<button type="button" onClick={() => toggleImage(i)}
											className={`w-6 h-6 rounded-full flex items-center justify-center ${img.enabled ? 'bg-green-600' : 
													'bg-gray-400'} text-white`}
											data-testid={`image-toggle-${i}`}>
								{ img.enabled ?
									<Eye className="w-3 h-3" /> : <EyeOff className="w-3 h-3" />
								}
							</button>
							{!img.isExisting && (
								<button type="button" onClick={() => removeImage(i)}
												className="w-6 h-6 bg-[#9B2C2C] text-white rounded-full flex items-center justify-center"
												data-testid={`image-remove-${i}`}>
									<X className="w-3 h-3" />
								</button>
							)}
						</div>
						{!img.enabled &&
							<div className="absolute inset-0 flex items-center justify-center bg-black/20 pointer-events-none">
								<span className="text-[10px] font-bold text-white bg-black/50 px-2 py-0.5 rounded">
									{t('horse.media_disabled')}
								</span>
							</div>
						}
					</div>
				))}
				<label
					className="aspect-square bg-[#F9F7F2] border-2 border-dashed border-[#E6E2D6] rounded-sm flex flex-col
							items-center justify-center cursor-pointer hover:border-[#8B4513] transition-colors"
					data-testid="image-upload">
					<Upload className="w-6 h-6 text-[#8B4513] mb-1" />
					<span className="text-[10px] text-[#666055]">{t('horse.add')}</span>
					<input type="file" multiple accept="image/*" onChange={ handleImages } className="hidden" />
				</label>
			</div>
		</Section>
	)
}